<template>
  <div>
    <h1>Viajes</h1>
    <b-row>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" class="form-control" placeholder="Buscar viaje"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3" class="my-1">
        <b-form-group label-cols-sm="3" label="Registros por página" class="mb-0">
          <b-form-select v-model="perPage" :options="pageOptions" class="form-control"></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
      <div class="card">
        <div class="card-body">
            <a-form>
                <div class="row">
                    <div class="col-md-6">
                        <a-form-item label="Fecha Inicio" has-feedback>
                            <a-date-picker v-model="startDate" style="width: 100%" @change="changeStartDate"/>
                        </a-form-item>
                    </div>
                  <div class="col-md-6">
                        <a-form-item label="Fecha Fin" has-feedback>
                            <a-date-picker v-model="endDate" style="width: 100%" @change="changeEndDate"/>
                        </a-form-item>
                    </div>
                </div>
            </a-form>
        </div>
    </div>
    <b-table
      show-empty
      stacked="md"
      :items="getTripsByConcesionarioIdAndDate"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      :key="tableIndex"
      empty-text="No existen registros por mostrar"
      emptyFilteredText="No existen registros por mostrar"
    >
      <template v-slot:cell(totalTripAmount)='row' >
        {{ '$'+ row.item.totalTripAmount}}
      </template>
    <!--totalTripAmount
      <template v-slot:cell(origin)='row' >
        <p v-if="currentPageItemsAddresses[row.item.id]">{{currentPageItemsAddresses[row.item.id].origin}}</p>
      </template>
      <template v-slot:cell(destiny)='row' >
        <p v-if="currentPageItemsAddresses[row.item.id]">{{currentPageItemsAddresses[row.item.id].destiny}}</p>
      </template> -->
      <template v-slot:cell(cancelled)='row' >
        <!--<p v-if="currentPageItemsAddresses[row.item.id]">{{currentPageItemsAddresses[row.item.id].destiny}}</p>-->
        {{ row.item.cancelled ? 'Cancelado' : 'Completado' }}
      </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <div class="text-center" v-if="$apollo.queries.getTripsByConcesionarioIdAndDate.loading">
        <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
    </div>
    </div>
</template>

<script>
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
export default {
  data() {
    return {
      getTripsByConcesionarioIdAndDate: [],
      filteredItems: [],
      fields: [
        { key: 'id', label: 'ID de viaje', sortable: true, sortDirection: 'desc' },
        { key: 'tripOrigin', label: 'Origen' },
        { key: 'tripDestination', label: 'Destino' },
        { key: 'startedAt', label: 'Fecha y hora de inicio' },
        { key: 'finishedAt', label: 'Fecha y hora de fin' },
        { key: 'driver.firstName', label: 'Nombre(s) del conductor' },
        { key: 'driver.lastName', label: 'Apellidos del conductor' },
        { key: 'totalTripAmount', label: 'Costo Total' },
        { key: 'concesionNumber', label: 'Número de concesión' },
        { key: 'concesion.concesionario.name', label: 'Concesionario' },
        { key: 'cancelled', sortable: true, label: 'Estatus de viaje' },
      ],
      currentPageItemsAddresses: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      startDate: null,
      endDate: null,
      concesionarioId: 0,
      tableIndex: 0,
      tripTypes: ['Aplicación', 'Todos', 'Sin Aplicación'], // 'Sin Aplicacion'],
      tripType: null,
    }
  },
  apollo: {
    getTripsByConcesionarioIdAndDate: {
      query: gql`query getTripsByConcesionarioIdAndDate($concesionarioId:Int!, $startDate:String!, $endDate: String!){
          getTripsByConcesionarioIdAndDate(concesionarioId: $concesionarioId startDate: $startDate endDate: $endDate){
            id
            pickUpLng
            pickUpLat
            destinationLat
            destinationLng
            startedAt
            finishedAt
            tripOrigin
            tripDestination
            cancelled
            concesionNumber
            concesion{
              concesionario{
                name
                id
              }
            }
            totalTripAmount
            driver{
             firstName
             lastName
            }
            driverId
        }
      }`,
      context: headers(),
      variables() {
        return {
          concesionarioId: this.concesionarioId,
          startDate: this.startDate,
          endDate: this.endDate,
        }
      },
      error (erro) {
        console.log(erro)
      },
      result ({ data, loading, networkStatus }) {
        console.log(data)
        this.totalRows = data.getTripsByConcesionarioIdAndDate.length
      },
    },
  },
  created: function () {
    // `this` hace referencia a la instancia vm
    this.concesionarioId = parseInt(this.getFranchisee)
    // console.log(this.getFranchisee)
  },
  methods: {
    onFiltered(filtered) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filtered.length
      this.currentPage = 1
    },
    defineDate(date) {
      const dates = new Date(date)
      const year = (dates.getFullYear())
      var month = (parseInt(dates.getMonth() + 1))
      var day = (dates.getDate())
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return [year, month, day].join('-')
    },
    changeStartDate(event) {
      if (event) {
        this.startDate = this.defineDate(event._d)
        // console.log(this.tripType)
        this.searchByType(this.tripType)
      } else {
        this.todayDate()
        // this.searchByType(this.tripType)
      }
    },
    changeEndDate(event) {
      if (event) {
        this.endDate = this.defineDate(event._d)
        this.searchByType(this.tripType)
      } else {
        this.todayDate()
        // this.searchByType(this.tripType)
      }
    },
    todayDate() {
      const today = new Date()
      const year = (today.getFullYear())
      var month = (parseInt(today.getMonth() + 1))
      var day = (today.getDate())
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      this.startDate = [year, month, day].join('-')
      this.endDate = [year, month, day].join('-')
    },
  },
  mounted() {
    this.todayDate()
  },
  computed: {
    getFranchisee() {
      return this.$store.state.user.franchisee
    },
  },
}
</script>

<style>

</style>
